import { childDocument, medicalDocument, concieveMethod, subDocument, documentsType } from './configData';
import React from 'react';

export const pregnancyColumns = [
  {
    dataField: 'Serial',
    text: 'S.No',
    isDummyField: true,
    formatter: (cell, row, rowIndex) => rowIndex + 1,
    align: "center",
    headerAlign: 'center'
  }, {
    dataField: 'documentDetails.appointment',
    text: 'Date of appointment',
    align: "center",
    headerAlign: 'center'
  }, {
    dataField: 'hospitalName',
    text: 'Hospital/Clinic',
    align: "center",
    headerAlign: 'center'
  }, {
    dataField: 'gynecologistName',
    text: 'Gynecologist Name',
    align: "center",
    headerAlign: 'center'
  }, {
    dataField: 'documentDetails.title',
    text: 'Title of Documents',
    align: "center",
    headerAlign: 'center'
  }
]

export const concieveColumns = [
  {
    dataField: "concieveMethod",
    text: "Concieve Method",
    formatter: (cell, row, rowIndex, data) => data[cell].label,
    formatExtraData: concieveMethod,
    headerAlign: 'center'
  }
]

export const subtypeColums = [
  {
    dataField: "subtypeDocument",
    text: "Sub Type of Document",
    formatter: (cell, row, rowIndex, data) => data[cell].label,
    formatExtraData: subDocument,
    headerAlign: 'center'
  }
]

export const documentTypeColumns = [
  {
    dataField: "documentDetails.documentType",
    text: "Type of document",
    formatter: (cell, row, rowIndex, data) => data[row.pregnancyStage][cell].label,
    formatExtraData: documentsType,
    headerAlign: 'center'
  }
]

export const childColumns = [
  {
    dataField: 'Serial',
    text: 'S.No',
    isDummyField: true,
    formatter: (cell, row, rowIndex) => rowIndex + 1,
    align: "center",
    headerAlign: 'center'
  }, {
    dataField: "document.appointment",
    text: "appointment",
    align: "center",
    headerAlign: 'center'
  }, {
    dataField: "hospitalName",
    text: "Hospital/Clinic",
    align: "center",
    headerAlign: 'center'
  }, {
    dataField: "doctorName",
    text: "Doctor Name",
    align: "center",
    headerAlign: 'center'
  }, {
    dataField: "document.documentType",
    text: "Type of document",
    formatter: (cell, row, rowIndex, data) => data[cell].label,
    formatExtraData: childDocument,
    align: "center",
    headerAlign: 'center'
  }, {
    dataField: "document.files",
    text: "File uploaded",
    formatter: (cell) => cell.length,
    align: "center",
    headerAlign: 'center'
  }
  // ...downloadColumns
]

export const medicalColumns = [
  {
    dataField: 'Serial',
    text: 'S.No',
    isDummyField: true,
    formatter: (cell, row, rowIndex) => rowIndex + 1,
    align: "center",
    headerAlign: 'center'
  }, {
    dataField: "document.appointment",
    text: "appointment",
    align: "center",
    headerAlign: 'center'
  }, {
    dataField: "hospitalName",
    text: "Hospital/Clinic",
    align: "center",
    headerAlign: 'center'
  }, {
    dataField: "doctorName",
    text: "Doctor Name",
    align: "center",
    headerAlign: 'center'
  }, {
    dataField: "document.documentType",
    text: "Type of document",
    formatter: (cell, row, rowIndex, data) => data[cell].label,
    formatExtraData: medicalDocument,
    align: "center",
    headerAlign: 'center'
  }, {
    dataField: "document.files",
    text: "File uploaded",
    formatter: (cell) => cell.length,
    align: "center",
    headerAlign: 'center'
  }
]

export const thyroidColumns = [
  {
    dataField: 'Serial',
    text: 'S.No',
    isDummyField: true,
    formatter: (cell, row, rowIndex) => rowIndex + 1,
    align: "center",
    headerAlign: 'center'
  }, {
    dataField: "testDate",
    text: "Date & Time of test",
    headerAlign: 'center'
  }, {
    dataField: "lab",
    text: "Lab Name",
    headerAlign: 'center'
  }, {
    dataField: "t3",
    text: "T3 Levels(ng/dl)",
    headerAlign: 'center'
  }, {
    dataField: "t4",
    text: "T4 Levels(ng/dl)",
    headerAlign: 'center'
  }, {
    dataField: "ft3",
    text: "FT3 Levels(ng/dl)",
    headerAlign: 'center'
  }, {
    dataField: "ft4",
    text: "FT4 Levels(ng/dl)",
    headerAlign: 'center'
  }, {
    dataField: "tsh",
    text: "TSH Levels(ng/dl)",
    headerAlign: 'center'
  }
]


export const bloodSugarColumns = [
  {
    dataField: 'Serial',
    text: 'S.No',
    isDummyField: true,
    formatter: (cell, row, rowIndex) => rowIndex + 1,
    align: "center",
    headerAlign: 'center'
  }, {
    dataField: "testDate",
    text: "Date & Time of test",
    headerAlign: 'center'
  }, {
    dataField: "lab",
    text: "Lab Name",
    headerAlign: 'center'
  }, {
    dataField : "HbA1c",
    text: "HbA1c(in %)",
    headerAlign: 'center'
  }, {
    dataField: "preMealBloodSugar",
    text: "Pre Meal Blood Sugar(mg/dl)",
    headerAlign: 'center'
  }, {
    dataField: "postMealBloodSugar",
    text: "Post Meal Blood Sugar(mg/dl)",
    headerAlign: 'center'    
  }, {
    dataField: "urineSugarF",
    text: "UrineSugar(mg/dl)",
    headerAlign: 'center'
  }, {
    dataField: "urineSugarPP",
    text: "UrineSugar(pp)(mg/dl)",
    headerAlign: 'center'
  }
]

export const bloodPressureColumns = [
  {
    dataField: 'Serial',
    text: 'S.No',
    isDummyField: true,
    formatter: (cell, row, rowIndex) => rowIndex + 1,
    align: "center",
    headerAlign: 'center'
  }, {
    dataField: "testDate",
    text: "Date & Time of test",
    headerAlign: 'center'
  }, {
    dataField: "lab",
    text: "Lab Name",
    headerAlign: 'center'
  }, {
    dataField: "systolicBloodPressure",
    text: "Blood Pressure(systolic)(mmHg)",
    headerAlign: 'center'
  }, {
    dataField: "pulseRate",
    text: "Pulse Rate(bpm)",
    headerAlign: 'center'
  }, {
    dataField: "diastolicBloodPressure",
    text: "Blood Pressure(Diastolic)(mmHg)",
    headerAlign: 'center'
  } 
]

export const downloadColumns = [
  {
    dataField: "download",
    text: "Download",
    isDummyField: true,
    formatter: (cell, row, rowIndex) => <span className="fa fa-download"></span>,
    align: "center",
    events: {
      onClick: (e, column, columnIndex, row) => this.props.handleDownload(row._id)
    }
  }
]




// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/Columns.js